import { firebase } from '../config/firebase.client';
import { IApiDirectionsResultType } from '../types';


interface CoordsResult {
    coords: {
        lat: number;
        lng: number;
    };
}

interface AddressResult {
    address: string;
}


const isDev = typeof __DEV__ !== 'undefined' ? __DEV__ : process.env.NODE_ENV === 'development';

export const fetchMunicipality = async (lat: string, lng: string): Promise<string | any> => {
    if (isDev) console.log('[DEV] fetchMunicipality chamada');

    try {
        const data = await firebase.callFunction('googleapis-googleApisGetMunicipality', {
            lat: lat,
            lng: lng,
        });

        if (data) return data;
        return 'Nenhum resultado encontrado';
    } catch (error) {
        const msg = (error as Error).message || 'Erro na função fetchMunicipality';
        console.error(msg);
        throw error;
    }
};

export const fetchCoordsfromPlace = async (place_id: string): Promise<string | any> => {
    if (isDev) console.log('[DEV] fetchCoordsfromPlace chamada');

    try {
        const data = await firebase.callFunction('googleapis-googleApisGetCoords', { place_id }) as CoordsResult;

        if (data && data.coords) return data.coords;

        const msg = 'Nenhuma coordenada encontrada';
        console.error(msg);
        return msg;
    } catch (error) {
        const msg = (error as Error).message || 'Erro na função fetchCoordsfromPlace';
        console.error(msg);
        throw error;
    }
};

export const fetchAddressfromCoords = async (latlng: string): Promise<string | any> => {
    if (isDev) console.log('[DEV] fetchAddressfromCoords chamada');

    try {
        const data = await firebase.callFunction('googleapis-googleApisGetAddress', { latlng }) as AddressResult;

        if (data && data.address) return data.address;

        const msg = 'Nenhum endereço encontrado';
        console.error(msg);
        return msg;
    } catch (error) {
        const msg = (error as Error).message || 'Erro na função fetchAddressfromCoords';
        console.error(msg);
        throw error;
    }
};

export const getDirectionsApi = async (
    startLoc: string,
    destLoc: string,
    waypoints?: string
): Promise<undefined | IApiDirectionsResultType> => {
    if (isDev) console.log('[DEV] getDirectionsApi chamada');

    try {
        const body: any = { start: startLoc, dest: destLoc };
        if (waypoints) body.waypoints = waypoints;

        const data = await firebase.callFunction('googleapis-googleApisGetDirections', body) as IApiDirectionsResultType;

        if (data && data.distance_in_km !== undefined) return data;

        const msg = 'Erro ao obter direções';
        console.error(msg);
        return undefined;
    } catch (error) {
        const msg = (error as Error).message || 'Erro na função getDirectionsApi';
        console.error(msg);
        throw error;
    }
};